'use client';

import React from 'react';
import { ArticleBlock, ArticleBlockPlaceholder, ArticleData } from '@benzinga/article-manager';

import { ArticleBlocks } from './ArticleBlocks';
import { OptimizelyCampaignifyBlock } from './Blocks/OptimizelyCampaignifyBlock';
import { VideoArticleYouTubeCTA } from './VideoArticleYouTubeCTA';

interface VideoArticleBodyProps {
  articleData: ArticleData;
}

const isRenderableArticleBlock = (block: ArticleBlock | ArticleBlockPlaceholder): block is ArticleBlock =>
  'innerHTML' in block;

export const VideoArticleBody: React.FC<VideoArticleBodyProps> = ({ articleData }) => {
  const blocks: Array<ArticleBlock | ArticleBlockPlaceholder> = Array.isArray(articleData.blocks)
    ? articleData.blocks
    : [];
  const bodyBlocks = blocks.filter(isRenderableArticleBlock);

  return (
    <>
      <ArticleBlocks blocks={bodyBlocks} />

      <VideoArticleYouTubeCTA />

      <OptimizelyCampaignifyBlock nodeID={String(articleData.nodeId)} placeholderId="bottom" />
    </>
  );
};
